<template>
  <div>
    <div class="app-showcase-process-step__one mb-40">
      <div class="container-fluid container-fluid--cp-150">
        <div class="row flex-column-reverse flex-lg-row align-items-center">
          <div class="col-lg-5 col-md-5">
            <div class="app-showcase-process-step__media text-center wow move-up">
              <img :src="img" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="app-showcase-process-step__content section-space--mt_40">
              <div class="app-showcase__inner">
                <h4 class="font-weight--light wow move-up">{{ title }}</h4>
                <div class="sub-text section-space--mb_40 wow move-up">
                  {{ desc }}
                </div>
                <div class="sub__title mb-20 wow move-up">
                  <h6 class="font-weight--blod">{{ subtitle }}</h6>
                </div>
                <!-- <div class="sub-text section-space--mb_40 wow move-up">
                {{ info }}
              </div> -->
                <div class="wow move-up">
                  <b-form @submit="onSubmit" v-if="show">
                    <b-form-group id="input-group-1" label="Email Address:" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="form.email"
                        type="email"
                        placeholder=""
                        required
                        class="form-input"
                      ></b-form-input>
                    </b-form-group>

                    <div class="btn-sowcase section-space--mb_40 wow move-up">
                      <b-button type="submit" variant="primary" class="scroll btn btn--green"
                        >Send Email</b-button
                      >
                    </div>

                    <!-- testing -->
                    <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
                  </b-form>
                  <!-- <b-card class="mt-3" header="Form Data Result">
                                <pre class="m-0">{{ form }}</pre>
                                </b-card> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import axios from 'axios'

import FooterMain from '@/components/FooterMain'

import { handleGlobalError } from '../util'

export default {
  name: 'ForgotPassword',
  components: {
    FooterMain,
  },
  data() {
    return {
      img: require('../assets/img/hero/startup/top.png'),
      subtitle: '',
      title: 'Forgot Password?',
      desc: 'Input your email address and we will send a verification code to change your password.',
      form: {
        email: '',
      },
      show: true,
    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault()
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'sendResetPwd',
          value: { email: this.form.email },
          notifierOptions: { preferredComm: 'email' },
        })
        this.$store.commit('updateEmail', this.form.email)
        // alert(JSON.stringify(user))
        this.$router.push({ path: `change-password` })
      } catch (error) {
        console.error('email is invalid', error)
        handleGlobalError(this, error, 'send a verification code')
      }
    },
  },
}
</script>
